import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { sanitizeTitle } from './helpers';
import Caroussel from './Caroussel';

document.addEventListener("DOMContentLoaded",()=>{
  const rootContainer = document.getElementById('pagemarques-react-app');
  if (rootContainer) {
    const root = ReactDOM.createRoot(rootContainer);
    if (root) {
      root.render(
        <React.StrictMode>
          <App data={window.pageMarquesReactData} />
        </React.StrictMode>
      );
    }
  }

    const catalogsContainers = document.querySelectorAll(".pagemarques-react-catalog");
    catalogsContainers.forEach((el) => {
    if (el) {
      const category_id = sanitizeTitle(el.dataset.category);
      const data = window.pageMarquesReactData;
      const category = data.data.categories.find(v => sanitizeTitle(v.name) === category_id);
      category.brands = [...category.brands.filter(v => v.catalogs.length > 0).filter(v=>data.catalogs[sanitizeTitle(category.name)][v.name].activated).map((v) => {
        return {
          ...v,
          "catalog_redirect_url": data.catalogs[sanitizeTitle(category.name)][v.name].url
        }
      })];
      const filtered_data = {
        ...data,
        "data": {
          ...data.data,
          "categories": [category],
          "all_brands": category.brands
        },
        "params": {
          ...data.params,
          "displayCategories": false
        }
      }
      const catalog_root = ReactDOM.createRoot(el);
      catalog_root.render(
        <React.StrictMode>
          <div>
            <h3 className='mb-8 text-center'>{category.brands.length > 1 ? "Catalogues" : "Catalogue"} {["a","e","i","o","u","y"].includes(sanitizeTitle(category.name)[0]) ? "d'" : "de "}{category.name}</h3>
            <App data={filtered_data} />
          </div>
        </React.StrictMode>
      );
    }
  });

  const carousselsContainers = document.querySelectorAll(".pagemarques-caroussel");
    carousselsContainers.forEach((carousselContainer)=>{
      const carousselData = carousselContainer.dataset;
      const data = window.pageMarquesReactData;
      const root = ReactDOM.createRoot(carousselContainer);
      if(root){
        root.render(
          <React.StrictMode>
            <Caroussel data={data} {...carousselData} ease={JSON.parse(carousselData.ease)}/>
          </React.StrictMode>
        )
      }

    });
});

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
